export var MARGIN_XX_SMALL = '0.25rem';
export var MARGIN_X_SMALL = '0.5rem';
export var MARGIN_SMALL = '0.75rem';
export var MARGIN_MEDIUM = '1rem';
export var MARGIN_LARGE = '1.5rem';
export var MARGIN_X_LARGE = '2rem';
export var MARGIN_XX_LARGE = '3rem';